import { motion } from "framer-motion";
import { ScanLine, BellRing, Sparkles } from "lucide-react";
import StoreBadges from "@/components/StoreBadges";
import Announcement from "@/components/Announcement";
import { HERO_IMG, SITE } from "@/data/site";

const EASE = [0.22, 1, 0.36, 1];

export default function Hero() {
  return (
    <section className="relative overflow-hidden grain vault-grid-bg pt-20" data-testid="hero">
      <Announcement />
      <div className="relative z-10 mx-auto grid max-w-7xl items-center gap-12 px-5 pb-16 pt-12 sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:pb-28 lg:pt-16">
        <div>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: EASE }}
            className="inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold/10 px-3.5 py-1.5"
          >
            <Sparkles className="h-3.5 w-3.5 text-gold" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">Now on Google Play · iOS coming soon</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.08, ease: EASE }}
            className="mt-6 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-balance sm:text-5xl lg:text-6xl"
          >
            Never Miss a <span className="text-gold">Warranty</span> Again
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.16, ease: EASE }}
            className="mt-5 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg"
          >
            Store, track, and manage all your receipts, warranties, and product documents in
            one secure place — protected like a vault, accessible anywhere.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.24, ease: EASE }}
            className="mt-8"
          >
            <StoreBadges />
            <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
              <span className="inline-flex items-center gap-2"><ScanLine className="h-4 w-4 text-sage" /> Smart OCR receipt scanning</span>
              <span className="inline-flex items-center gap-2"><BellRing className="h-4 w-4 text-sage" /> On-time expiry reminders</span>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.94, y: 30 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.2, ease: EASE }}
          className="relative mx-auto w-full max-w-sm"
        >
          <div className="absolute -inset-6 -z-10 animate-glow-pulse rounded-[2.5rem] bg-sage/20 blur-3xl" />
          <div className="overflow-hidden rounded-[2rem] border border-border shadow-2xl ring-1 ring-white/5">
            <img
              src={HERO_IMG}
              alt="Warranty_Vault pro app dashboard showing receipts, active warranties and total value"
              className="w-full"
              loading="eager"
            />
          </div>
        </motion.div>
      </div>
      <p className="sr-only">{SITE.tagline}</p>
    </section>
  );
}
